<template>
	<modal @close="close">
		<div class="item-modal" v-if="data">
			<div class="container">
				<div class="date" v-text="date"/>
				<div class="title" v-text="data.title"/>
			</div>

			<div class="image" v-if="image"><img :src="image"/></div>

			<div class="container">
				<div class="content">
					<vHtml v-if="data.content" v-bind="{markdown: data.content}"/>
				</div>
			</div>
		</div>
	</modal>
</template>

<script>
import {date} from "@/modules/utils";
import modal from "@/components/modal.vue";
import vHtml from "@/components/html.vue";

export default {
	components: {modal, vHtml},
	props: {
		slug: {type: String, required: true}
	},
	data() {
		return {
			data: null
		}
	},
	computed: {
		image: (t) => t.data.image ? t.data.image.url : null,
		date: (t) => date(t.data.published_at).string
	},
	methods: {
		close() {
			this.$emit("close");
		},
		async getData() {
			const {data: {data}} = await this.$axios.get(`client/news-items/${this.slug}`);
			this.data = data;
			this.$store.commit("news/visited", data);
		}
	},
	created() {
		this.getData();
	}
};
</script>

<style lang="scss" scoped>
.item-modal {
	max-width: 430px;
	margin: 0 auto;

	.container {
		margin: 0 auto;
	}

	.date {
		font-size: 12px;
		font-weight: 300;
		color: #B1B1B1;
		margin-bottom: 8px;
	}

	.title {
		font-size: 22px;
		font-weight: 700;
		color: #4A4A4A;
		margin-bottom: 2em;
	}

	.image {
		margin-bottom: 2em;

		img {
			display: block;
		}
	}
	.content {
		font-weight: 300;
		font-size: 14px;
		line-height: 24px;
	}
}
</style>
